import { render, staticRenderFns } from "./DashboardAbastoView.vue?vue&type=template&id=b7234632"
import script from "./DashboardAbastoView.vue?vue&type=script&lang=js"
export * from "./DashboardAbastoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports